<template>
    <div class="ah-page index-page" v-if="!isMenuLoading">
        <FAScreen v-if="isPFAgent" />
        <div v-else-if="isSAAdmin || isInitialed">
            <div class="page-header alpha-bg">
                <div style="padding: 20px 0 0 0"></div>
            </div>
            <div class="page-body">
                <div class="ah-container">
                    <el-alert :type="daysToExpire <= 3 ? 'error' : 'warning'" v-if="isAuth('B03') && daysToExpire <= 7" center>
                        貴公司的 Sokuji 使用期限將在 {{ daysToExpire }} 天內到期，請聯絡業務或客服人員為您辦理續約。
                    </el-alert>
                    <div class="ah-panel">
                        <div class="page-sub-tab">
                            <div class="left-cell">
                                <div class="user-infos">
                                    <img class="user-icon" src="@/assets/img/user-icon.svg" alt="User Avatar" />
                                    <div class="name">{{ userName }}</div>
                                    <div v-if="!isAhooAgent" class="email">{{ userEmail }}</div>
                                </div>
                            </div>
                            <div class="right-cell">
                                <div class="sub-tab">
                                    <div
                                        :class="{
                                            item: true,
                                            active: indexTab == 'overview'
                                        }"
                                    >
                                        <span class="btn" v-if="isAuth('D11') || isAuth('D12') || isAuth('D14') || isAuth('D15')" @click="handleIndexTabClick('overview')" @keydown="() => {}"
                                            >財務概況</span
                                        >
                                    </div>
                                    <div
                                        :class="{
                                            item: true,
                                            active: indexTab == 'todos'
                                        }"
                                    >
                                        <span class="btn" @click="handleIndexTabClick('todos')" @keydown="() => {}"
                                            >待辦單據 <span class="number" v-if="todoCount > 0">{{ todoCount }}</span></span
                                        >
                                    </div>
                                    <div v-if="isAuthorityTabShow" class="item" :class="{ active: indexTab == 'authority' }">
                                        <span class="btn" @click="handleIndexTabClick('authority')" @keydown="() => {}">身份功能</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <NoneTransferAccountHint v-if="showNoneTransferAccountHint" />
                    <!-- <div
                        v-if="!isAhooAgent && isPaymentAccountValid === false"
                        class="ah-panel padding main-bg-color payment-account-warning"
                    >
                        <h2>請設定薪轉帳戶</h2>
                        <div class="msg">您尚未設定薪轉帳戶，這方便您請款時自動帶入帳戶資訊，請儘早設定。</div>
                        <el-button
                            type="normal"
                            plain
                            @click="$router.push({name: 'profile'})"
                        >
                            設定薪轉帳戶
                        </el-button>
                    </div> -->
                </div>
            </div>
            <IndexOverviews v-if="indexTab == 'overview'"></IndexOverviews>
            <div v-if="indexTab == 'authority'">
                <div class="ah-container">
                    <div class="ah-panel padding">
                        <div style="text-align: right">
                            <el-radio-group v-model="authorityTableDisplayType" size="mini">
                                <el-radio-button label="self">可用</el-radio-button>
                                <el-radio-button label="all">全部</el-radio-button>
                            </el-radio-group>
                        </div>
                        <ah-authority-table v-model="userUntList" :disabled="true" :show-only-enabled="authorityTableDisplayType == 'self'" :show-prefer-role="false" style="margin-bottom: 20px" />
                    </div>
                </div>
            </div>
            <div v-if="indexTab == 'todos'">
                <div class="ah-container">
                    <div class="ah-panel task-panel" style="margin-top: 25px">
                        <el-tabs class="ah-panel-tab" type="" v-model="activeTab" @tab-click="handleTapClick">
                            <el-tab-pane name="1">
                                <template slot="label">
                                    <div class="tab-label">
                                        待辦請款單
                                        <span class="data-count">{{ payments.length }}</span>
                                    </div>
                                </template>
                                <div class="panel-body task-tab-inner">
                                    <PaymentTable :datas="paymentsForTable" :isSortByDate="true" :loading="false" :batchMode="false" non-custom-sort @detailClose="handlePaymentDetailClose" />
                                </div>
                            </el-tab-pane>
                            <el-tab-pane name="2">
                                <template slot="label">
                                    <div class="tab-label">
                                        請款待補單據
                                        <span class="data-count">{{ pageInfo.myMissReceiptPayments.length }}</span>
                                    </div>
                                </template>
                                <div class="panel-body task-tab-inner">
                                    <PaymentTable :datas="pageInfo.myMissReceiptPayments" :loading="isLoading" :isSortByDate="false" non-custom-sort @detailClose="handlePaymentDetailClose" />
                                </div>
                            </el-tab-pane>
                            <el-tab-pane name="3">
                                <template slot="label">
                                    <div class="tab-label">
                                        待辦發票
                                        <span class="data-count">{{ invoicesForTable.length }}</span>
                                    </div>
                                </template>
                                <div class="panel-body task-tab-inner">
                                    <InvoiceTable :datas="invoices" :loading="isLoading" :isSortByDate="false" @detailClose="handleInvoiceDetailClose" />
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </div>
            </div>
        </div>
        <FirstInitMsg v-else />
    </div>
</template>
<script>
import moment from 'moment';
import PaymentTable from '@/components/dashboard/Payment/PaymentTable.vue';
import InvoiceTable from '@/components/dashboard/Invoice/InvoiceTable.vue';
import ahAuthorityTable from '@/components/ui/ahAuthorityTable.vue';
import FirstInitMsg from './FirstInitMsg.vue';
import FAScreen from './FAScreen.vue';
import IndexOverviews from './IndexOverviews.vue';
import NoneTransferAccountHint from './NoneTransferAccountHint.vue';

export default {
    name: 'IndexPage',
    components: {
        PaymentTable,
        InvoiceTable,
        FirstInitMsg,
        FAScreen,
        IndexOverviews,
        ahAuthorityTable,
        NoneTransferAccountHint,
    },
    data() {
        return {
            announcementDialogVisible: false,
            indexTab: null,
            isLoading: false,
            activeTab: '1',
            showInvoiceList: false,
            showPaymentList: false,
            authorityTableDisplayType: 'self',
            role: localStorage.getItem('grP_NO'),
            pageInfo: {
                rejectedPayments: [],
                expiringPayments: [],
                watingApprovePayments: [],
                watingAuditPayments: [],
                myWatingApprovePayments: [],
                myWatingAuditPayments: [],
                missReceiptPayments: [],
                myMissReceiptPayments: [],
                toBeCreditedInvoice: [],
                waitingInvoice: [],
                myToBeCreditedInvoice: [],
                myWaitingInvoice: [],
            },
            invoiceList: [],
            paymentList: [],
            authorities: {},
            bankAccountInfo: {
                stafF_BNK_BOO: null,
                stafF_BNK_DOO: null,
                stafF_BNK_TPC: null,
                stafF_BNK_ACC: null,
            },
            personalInfo: {
                eml: null,
                nam: null,
                pJ_NO: null,
                boS_NAM: null,
            },
        };
    },
    computed: {
        isMenuLoading() {
            return this.$store.getters['menu/isLoading'];
        },
        isInitialed() {
            return this.$store.getters['menu/companyInfo'].iniT_FIN === 1;
        },
        isAuthLoaded() {
            return this.$store.getters['menu/isAuthLoaded'];
        },
        isAhooAgent() {
            return this.$store.getters['account/isAhooAgent'];
        },
        isSAAdmin() {
            return this.$store.getters['account/isSAAdmin'];
        },
        isPFAgent() {
            return this.$store.getters['account/isPFAgent'];
        },
        isAuthorityTabShow() {
            return !(this.isSAAdmin || this.isAhooAgent);
        },
        daysToExpire() {
            const endTime = this.$store.getters['menu/memberInfo'].edt;
            const endDate = moment(endTime);
            const currDate = moment();
            return endDate.diff(currDate, 'days') + 1;
        },
        isPaymentAccountValid() {
            if (this.personalInfo.eml !== null) {
                if (
                    this.bankAccountInfo.stafF_BNK_BOO === null
                    || this.bankAccountInfo.stafF_BNK_BOO === ''
                    // || this.bankAccountInfo.stafF_BNK_DOO === null
                    // || this.bankAccountInfo.stafF_BNK_DOO === ''
                    || this.bankAccountInfo.stafF_BNK_TPC === null
                    || this.bankAccountInfo.stafF_BNK_TPC === ''
                    || this.bankAccountInfo.stafF_BNK_ACC === null
                    || this.bankAccountInfo.stafF_BNK_ACC === ''
                ) {
                    return false;
                }
                return true;
            }
            return null;
        },
        userName() {
            return this.$store.getters['account/userName'];
        },
        userEmail() {
            return this.$store.getters['account/email'];
        },
        userUntList() {
            return this.$store.getters['account/untList'];
        },
        isEmployee() {
            return this.$store.getters['account/employee'];
        },
        peekBtnDataCount() {
            if (this.activeTab === '1') return this.payments.length;
            if (this.activeTab === '2') return this.invoices.length;
            return '';
        },
        todoCount() {
            return this.payments.length + this.pageInfo.myMissReceiptPayments.length + this.invoicesForTable.length;
        },
        paymentsForTable() {
            return this.payments;
        },
        invoicesForTable() {
            return this.invoices;
        },
        payments() {
            let datas = [];

            // 我的退件請款, sigN_STS: 4
            if (this.pageInfo.rejectedPayments) {
                datas = datas.concat(this.pageInfo.rejectedPayments);
            }

            // 待我處理請款（主管審核, 指定人, PM, sigN_STS: 1）
            if (this.pageInfo.watingAuditPayments) {
                datas = datas.concat(this.pageInfo.watingAuditPayments);
            }

            // 待我處理請款（待付款(A02), sigN_STS: 5）
            if (this.pageInfo.watingPendingPayments) {
                datas = datas.concat(this.pageInfo.watingPendingPayments);
            }

            // 待我確認付款（A03, sigN_STS: 2）
            if (this.pageInfo.watingApprovePayments) {
                datas = datas.concat(this.pageInfo.watingApprovePayments);
            }

            return datas;
        },
        invoices() {
            let datas = [];

            // 我的退件發票
            if (this.pageInfo.myRejectInvoice) {
                datas = datas.concat(this.pageInfo.myRejectInvoice);
            }

            // 待我處理發票（主管審核、開立(B02)）
            if (this.pageInfo.waitinAudtingInvoice) {
                datas = datas.concat(this.pageInfo.waitinAudtingInvoice);
            }

            // 待我入帳發票（B03）
            if (this.pageInfo.toBeCreditedInvoice) {
                datas = datas.concat(this.pageInfo.toBeCreditedInvoice);
            }

            return datas;
        },
        getMyToBeCreditedInvoiceAmount() {
            return this.pageInfo.myToBeCreditedInvoice.reduce((accumulator, currentValue) => accumulator + currentValue.amt, 0);
        },
        getToBeCreditedInvoiceAmount() {
            return this.pageInfo.toBeCreditedInvoice.reduce((accumulator, currentValue) => accumulator + currentValue.amt, 0);
        },
        getWaitingInvoiceAmount() {
            return this.pageInfo.waitingInvoice.reduce((accumulator, currentValue) => accumulator + currentValue.amt, 0);
        },
        getMyWaitingInvoiceAmount() {
            return this.pageInfo.myWaitingInvoice.reduce((accumulator, currentValue) => accumulator + currentValue.amt, 0);
        },
        getMissReceiptPaymentsAmount() {
            return this.pageInfo.missReceiptPayments.reduce((accumulator, currentValue) => accumulator + currentValue.amt, 0);
        },
        getMyWatingAuditPaymentsAmount() {
            return this.pageInfo.myWatingAuditPayments.reduce((accumulator, currentValue) => accumulator + currentValue.amt, 0);
        },

        showNoneTransferAccountHint() {
            return !this.isAhooAgent && !this.isSAAdmin && this.isPaymentAccountValid === false && this.isEmployee;
        },
    },
    watch: {
        isAuthLoaded(val) {
            if (val) this.updateIndexTabStaus();
        },
    },
    created() {
        this.updateData();
        this.fetchProfileData();

        if (this.isAuthLoaded) this.updateIndexTabStaus();

        // 帳號管理員
        if (this.$store.getters['account/isAccAdmin']) {
            this.$router.replace({ name: 'staff' });
        }
    },
    methods: {
        updateIndexTabStaus() {
            if (this.isAuth('D11') || this.isAuth('D12') || this.isAuth('D14') || this.isAuth('D15')) {
                const prevIndexTab = localStorage.getItem('indexTab');
                if (prevIndexTab === 'todos') {
                    this.indexTab = 'todos';
                } else {
                    this.indexTab = 'overview';
                }
            } else {
                this.indexTab = 'todos';
            }
        },
        fetchProfileData() {
            this.$api({
                url: '/ProfilePage/GetProfile',
                method: 'GET',
            }).then((resp) => {
                this.authorities = resp.data.authorities;
                this.bankAccountInfo = resp.data.bankAccountInfo;
                this.personalInfo = resp.data.personalInfo;
            });
        },
        updateData() {
            this.isLoading = true;
            return this.$api({
                url: 'PersnoalMainPage/GetPersnalInfo',
                method: 'GET',
            })
                .then((result) => {
                    this.pageInfo = result.data;

                    if (this.payments.length === 0) {
                        if (this.invoices.length > 0) {
                            this.activeTab = '3';
                        } else if (this.pageInfo.myMissReceiptPayments.length > 0) {
                            this.activeTab = '2';
                        }
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        onEditBankBtnClick() {
            this.$router.push({ name: 'profile' });
        },
        handlePaymentDetailClose(refresh) {
            if (refresh) {
                this.updateData();
            }
        },
        handleInvoiceDetailClose(refresh) {
            if (refresh) {
                this.updateData();
            }
        },
        navigateTo(target) {
            switch (target) {
            case 'invoice':
                this.$router.push({ name: 'invoice-add' });
                break;
            case 'payment':
                this.$router.push({ name: 'payment-add' });
                break;
            case 'project':
                this.$router.push({ name: 'project-add' });
                break;
            case 'client':
                this.$router.push({ name: 'vendor-add' });
                break;
            default:
                break;
            }
        },
        handleTapClick() {},

        handleIndexTabClick(id) {
            if (this.indexTab !== id) {
                this.indexTab = id;
                localStorage.setItem('indexTab', id);
            }
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.index-page {
    .page-sub-tab {
        display: table;
        width: 100%;
        min-height: 76.2px;
        @media (max-width: 720px) {
            display: block;
        }

        > .left-cell {
            display: table-cell;
            vertical-align: top;
            @media (max-width: 720px) {
                display: block;
            }
        }

        > .right-cell {
            display: table-cell;
            vertical-align: top;
            text-align: right;
            @media (max-width: 720px) {
                display: block;
            }
        }
    }

    .user-infos {
        position: relative;
        padding: 18px 0 15px 80px;

        .user-icon {
            position: absolute;
            top: 18px;
            left: 25px;
            width: 38px;
        }

        .name {
            font-size: 12pt;
            font-weight: bold;
            color: #444;
            line-height: 120%;
        }

        .email {
            font-size: 11pt;
            color: #888;
        }
    }

    .payment-account-warning {
        text-align: center;
        h2 {
            font-size: 15pt;
            margin: 0 0 10px 0;
        }
        .msg {
            margin: 0 0 10px 0;
        }
    }

    .sub-tab {
        display: table;
        margin: 25px 20px 0 auto;
        @media (max-width: 720px) {
            display: block;
            margin: 0 auto;
            padding: 0 0 10px 0;
            text-align: center;
        }

        > .item {
            display: table-cell;
            vertical-align: top;
            font-size: 11.5pt;

            &.active {
                > .btn {
                    color: $main-color;

                    > .number {
                        background-color: $main-color;
                    }
                }
            }

            > .btn {
                padding: 10px;
                color: #aaa;
                font-weight: bold;
                cursor: pointer;
                transition: 0.2s;
                margin: 0 8px;

                &:hover {
                    color: $main-color;

                    > .number {
                        background-color: $main-color;
                    }
                }

                > .number {
                    position: relative;
                    top: -2px;
                    font-weight: bold;
                    font-size: 9.2pt;
                    background-color: #ccc;
                    vertical-align: middle;
                    padding: 2px 4px;
                    border-radius: 5px;
                    color: #fff;
                    transition: 0.2s;
                }
            }
        }
    }

    .mainTab {
        .item {
            display: inline-block;
            cursor: pointer;
            padding: 0px 20px;
            height: 40px;
            line-height: 38px;
            font-size: 10.5pt;
            font-weight: bold;
            border: 1px solid #ffffff66;

            &.active {
                background-color: #ffffffcc;
                color: $main-color;
                // color: #fff;
            }

            &:first-child {
                border-top-left-radius: 10px;
                border-bottom-left-radius: 10px;
            }

            &:last-child {
                border-top-right-radius: 10px;
                border-bottom-right-radius: 10px;
                border-left: none;
            }

            .number {
                position: relative;
                top: -1px;
                background-color: #f95d5d;
                color: #fff;
                min-width: 35px;
                padding: 2px 6px;
                border-radius: 10px;
                font-size: 9pt;
                text-align: center;
            }
        }
    }

    .init-setup-panel {
        color: #fff;
        background-color: $main-color;
        padding: 30px;
        text-align: center;

        .title {
            font-size: 20pt;
            // color: $main-color;
        }

        .description {
            margin: 20px 0;
            font-size: 11pt;
        }

        .el-button {
            color: $main-color;
            font-weight: bold;
            font-size: 11pt;
        }
    }

    .task-panel {
        .panel-body.task-tab-inner {
            padding-top: 0;
        }

        // tab
        .el-tabs__header {
            .el-tabs__nav {
                border-radius: 0;

                .el-tabs__item {
                    line-height: 60px;
                    height: 60px;
                    padding: 0;
                    color: #555;
                    // border-top: 2px solid transparent;

                    &:nth-child(2),
                    &:nth-child(3) {
                        padding-left: 0px !important;
                        padding-right: 0px !important;
                    }

                    &.is-active {
                        // border-top: 3px solid #ff8000;
                        // height: 57px;
                        color: $main-color;
                    }

                    &:hover {
                        color: #000;
                        background-color: rgba(0, 0, 0, 0.03);
                    }

                    .tab-label {
                        font-size: 11.8pt;
                        padding: 0 30px 0 30px;
                        padding-top: 2px;

                        .data-count {
                            position: relative;
                            margin-top: -2px;
                            margin-left: 5px;
                            font-size: 10pt;
                            color: #222;
                        }
                    }
                }
            }
        }

        .ah-table.el-table {
            margin-top: 0;
        }
    }

    .ah-basic-data-table.profile-data {
        th {
            color: #fff;
            padding: 0;
        }

        td {
            color: #fff;
        }
    }
}
</style>
